import { ArrowUpRight, Building2, HardHat } from "lucide-react";

const services = [
  {
    icon: Building2,
    title: "Nettoyage de bureaux",
    img: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1400&q=80",
    desc:
      "Un environnement de travail impeccable, jour après jour. Entretien régulier ou ponctuel, adapté à votre rythme.",
    bullets: [
      "Bureaux, espaces communs, sanitaires",
      "Vitrerie intérieure & extérieure",
      "Cuisines & salles de réunion",
      "Désinfection des points de contact",
      "Plannings flexibles (jour / soir)",
    ],
  },
  {
    icon: HardHat,
    title: "Nettoyage de fin de chantier",
    img: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=1400&q=80",
    desc:
      "De la livraison gros-œuvre à la remise des clés : un chantier prêt à être habité, sans poussière, sans trace.",
    bullets: [
      "Dépoussiérage complet & aspiration",
      "Décollage colle, peinture, ciment",
      "Vitres, châssis, encadrements",
      "Sols : protection & lustrage",
      "Intervention rapide sur RDV",
    ],
  },
];

export default function Services() {
  return (
    <section id="services" className="section-pad relative">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 mb-20">
        <div className="lg:col-span-5">
          <div className="eyebrow mb-6">Nos services</div>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-light leading-[1]">
            Deux expertises,<br />
            <span className="italic text-[hsl(var(--accent))]">une seule exigence</span>.
          </h2>
        </div>
        <div className="lg:col-span-6 lg:col-start-7 flex items-end">
          <p className="text-muted-foreground text-base lg:text-lg leading-relaxed">
            Que vous gériez un siège social ou achevez un chantier de construction, Akay apporte la
            même rigueur. Des protocoles éprouvés, du matériel professionnel et une équipe identifiable
            qui respecte vos lieux.
          </p>
        </div>
      </div>

      <div className="grid lg:grid-cols-2 gap-6 lg:gap-8">
        {services.map((s, i) => (
          <article
            key={i}
            data-testid={`service-card-${i}`}
            className="group relative border border-border rounded-sm overflow-hidden bg-card/40 hover:border-[hsl(var(--accent))] transition-all duration-500"
          >
            <div className="relative aspect-[16/10] overflow-hidden">
              <img
                src={s.img}
                alt={s.title}
                className="w-full h-full object-cover transition-transform duration-[1.2s] group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-card via-card/30 to-transparent" />
              <s.icon className="absolute top-6 left-6 w-7 h-7 text-[hsl(var(--accent))]" />
              <div className="absolute top-6 right-6 text-xs uppercase tracking-[0.25em] text-foreground/70">
                0{i + 1}
              </div>
            </div>
            <div className="p-8 lg:p-10">
              <h3 className="text-3xl lg:text-4xl font-light mb-4">{s.title}</h3>
              <p className="text-muted-foreground leading-relaxed mb-6">{s.desc}</p>
              <ul className="space-y-2 mb-8">
                {s.bullets.map((b, j) => (
                  <li key={j} className="flex items-start gap-3 text-sm">
                    <span className="w-1.5 h-1.5 rounded-full bg-[hsl(var(--primary))] mt-2 shrink-0" />
                    <span className="text-foreground/90">{b}</span>
                  </li>
                ))}
              </ul>
              <a
                href="#devis"
                data-testid={`service-cta-${i}`}
                className="inline-flex items-center gap-2 text-sm uppercase tracking-[0.2em] text-[hsl(var(--accent))] border-b border-[hsl(var(--accent))]/30 hover:border-[hsl(var(--accent))] pb-1 transition-all"
              >
                Demander un devis
                <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
